import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgTriangleExclamationSolid = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 4.125c.499 0 .96.264 1.212.696l7.594 12.938a1.404 1.404 0 0 1-1.213 2.116H4.406c-.503 0-.97-.27-1.22-.707a1.41 1.41 0 0 1 .007-1.41l7.594-12.937a1.4 1.4 0 0 1 1.212-.696m0 4.5a.84.84 0 0 0-.844.844v3.937c0 .468.376.844.843.844a.84.84 0 0 0 .844-.844V9.47A.84.84 0 0 0 12 8.625m1.124 7.875A1.124 1.124 0 1 0 12 17.625c.623 0 1.125-.503 1.125-1.125"
    }));
export default SvgTriangleExclamationSolid;
